import React from "react";

const NoResults = () => {
    return (
        <div className="no-results">
            <p>No results found</p>
        </div>
    );
};

export default NoResults;